import { returnErrors } from './errorAction';
import { getApiCall, postApiCall } from '../utils/request';
import { WL_JOB_TITLE, SIGNUP_USER, LOGIN_USER, ACCEPT_INVITE, RESET_PASSWORD, FORGOT_PASSWORD, AUTO_LOGIN, AUTO_EXTERNAL_LOGIN, AUTO_EXTERNAL_LOGIN_FAILED } from '../actionType/type';


export const getJobTitles = (obj) => async (dispatch) => {
    const response = await getApiCall(`auth/careers`);
    if (response.data.success) {
        dispatch({ type: WL_JOB_TITLE, payload: response.data.data });
    }
    else {
        returnErrors(dispatch, response.data.message, response.status)
    }
}

export const userSignup = (obj) => async (dispatch) => {
    const response = await postApiCall(`auth/signup`, obj);
    if (response.data.success) {
        returnErrors(dispatch, response.data.message, response.status);
        dispatch({ type: SIGNUP_USER });
    }
    else {
        returnErrors(dispatch, response.data.message, response.status)
    }
}

export const verifyUser = (obj) => async (dispatch) => {
    const response = await postApiCall(`auth/verify`, obj);
    console.log(response.data.data)
    if (response.data.success) {
        dispatch({ type: AUTO_LOGIN, payload: response.data });
    }
    else {
        returnErrors(dispatch, response.data.message, response.status)
    }
}

export const userLogin = (login) => async (dispatch) => {
    const response = await postApiCall(`auth/login`, login);
    if (response.data.success) {
        dispatch({ type: LOGIN_USER, payload: response.data });
    }
    else {
        returnErrors(dispatch, response.data.message, response.status)
    }
}

export const acceptInvite = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`auth/accept-invite`, obj);
        if (response.data.success) {
            dispatch({ type: ACCEPT_INVITE, payload: response.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status)
        }

    } catch (error) {
        // returnErrors(dispatch,error.data.message, error.status)
    }
}

export const forgotPassword = (email) => async (dispatch) => {
    try {
        const response = await postApiCall(`auth/forgot-password`, { email: email });
        if (response.data.success) {
            dispatch({ type: FORGOT_PASSWORD, payload: response.data });
            returnErrors(dispatch, 'OTP is sent on your registered Email', response.status)
        }
        else {
            returnErrors(dispatch, response.data.message, response.status)
        }

    } catch (error) {
        // returnErrors(dispatch,error.data.message, error.status)
    }
}

export const resetPasswords = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`auth/reset-password`, obj);
        if (response.data.success) {
            dispatch({ type: RESET_PASSWORD, payload: response.data });
            returnErrors(dispatch, 'Password has been successfully changed', response.status)
        }
        else {
            returnErrors(dispatch, response.data.message, response.status)
        }

    } catch (error) {
        // returnErrors(dispatch,error.data.message, error.status)
    }
}

export const autoLogin = (code) => async (dispatch) => {
    let obj = { code: code }
    try {
        const response = await postApiCall(`admin/auth/autologin`, obj);
        if (response.data.success) {
            dispatch({ type: AUTO_LOGIN, payload: response.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status)
        }

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const autoExternalLogin = (code) => async (dispatch) => {
    let obj = { code: code }
    try {
        const response = await postApiCall(`auth/external/login`, obj);
        if (response.data.success) {
            dispatch({ type: AUTO_EXTERNAL_LOGIN, payload: response.data });
        }
        else {
            dispatch({ type: AUTO_EXTERNAL_LOGIN_FAILED, payload: response.data.message });
            returnErrors(dispatch, response.data.message, response.status)
        }

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const googlelogin = (login) => async (dispatch) => {
    let obj = {
        email: login.email
    }
    const response = await postApiCall(`auth/google`, obj);
    if (response.data.success) {
        dispatch({ type: LOGIN_USER, payload: response.data });
    }
    else {
        returnErrors(dispatch, response.data.message, response.status)
    }
}
